export const GenerateCodeTypes = {
  CreateTransferRequest: 'CreateTransferRequest',
  UpdateTransferRequest: 'UpdateTransferRequest',
} as const;
export type GenerateCodeTypes = (typeof GenerateCodeTypes)[keyof typeof GenerateCodeTypes];
